import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: string[];
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRoles }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is pending, they can ONLY visit the /pending route
  if (user?.role === 'pending' && location.pathname !== '/pending') {
    return <Navigate to="/pending" />;
  }

  // If user is NOT pending, they shouldn't be on the /pending route
  if (user?.role !== 'pending' && location.pathname === '/pending') {
    return <Navigate to="/dashboard" />;
  }

  if (requiredRoles && !requiredRoles.includes(user?.role || '') && !['super_admin', 'master_admin'].includes(user?.role || '')) {
    return <Navigate to="/dashboard" />;
  }

  return <>{children}</>;
};
